<template>
  <Breadcrumb />
  <div class="d-flex justify-content-between new-block">
    <h2></h2>
    <router-link
      :to="{
        name: 'PageLayoutTemplateNew',
      }"
      class="btn btn-success btn-action-new-page"
    >
      <i class="bi bi-plus"></i>
      {{
        $t(
          "PageLayoutTemplates.NewPageLayoutTemplate",
          {},
          { locale: this.$store.state.activeLang }
        )
      }}
    </router-link>
  </div>
  <Grid :settings="gridSettings" :columns="gridColumns" />
</template>
<script>
export default {
  name: "PageLayoutTemplateList",
  data() {
    return {
      gridSettings: {
        action: "PageLayoutTemplateList",
        requestUrl: String.format("/Lcdp-PageLayoutTemplateList"),
        requestUrlRouteParamNames: [],
        routeRequiredParameters: [
          {
            key: "pageLayoutTemplateId",
            value: "publicId",
            isRouteParameter: false,
          },
        ],

        serialNoLink: `#/SuperAdmin/PageLayoutTemplate/Edit/pageLayoutTemplateId=`,

        allowSearchPanel: false,
        allowExcelExport: false,
        allowDragAndDrop: false,
        allowPaging: true,
        allowDeleting: true,
        deleteActionUrl: "/Lcdp-PageLayoutTemplateDelete",
        autoOrderProcess: true,

        isGatewayRequest: true,

        buttons: [
          {
            name: "edit",
            cssClass: "btn-warning",
            iconClass: "bi-pencil-square",
            routeButton: true,
            routeObj: {
              name: "PageLayoutTemplateEdit",
              params: {
                pageLayoutTemplateId: "",
              },
            },
          },
        ],
      },
      gridColumns: [
        {
          text: this.$t(
            "BaseModelFields.Name",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "name",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.IsActive",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "isActive",
          type: "boolean",
          visible: true,
          width: 200,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.CreatedBy",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "createdByName",
          type: "string",
          visible: false,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.CreatedAt",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "createdAt",
          type: "datetime",
          visible: false,
          width: 0,
          template: "",
          format: this.$store.getters._dateTimeFormat,
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.UpdatedBy",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "updatedByName",
          type: "string",
          visible: false,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.UpdatedAt",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "updatedAt",
          type: "datetime",
          visible: false,
          width: 0,
          template: "",
          format: this.$store.getters._dateTimeFormat,
          textAlign: "",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
